import * as React from 'react';
import { observer } from 'mobx-react';
import { translate, ITranslationsCollection } from 'elc-service';

import { classes } from '../../utils/Classes';
import { PRODUCT_IMAGE_BADGE } from '../../constants/DataTestIdAttributes';

export interface IProductImageBadge {
    className?: string;
    productDisplayName?: string;
    productBadgeImage?: string;
    skuBadgeImage?: string;
    translations?: ITranslationsCollection;
}

const imageBadgeTranslations = ['productBadgeImageAlt', 'skuBadgeImageAlt'];

export const ProductImageBadge = translate(imageBadgeTranslations)(
    observer((props: IProductImageBadge) => {
        const { className, productDisplayName, productBadgeImage, skuBadgeImage } = props;
        const {
            productBadgeImageAlt,
            skuBadgeImageAlt
        } = props.translations as ITranslationsCollection;

        const productImageBadgeClassNames = classes('product-image-badge', className);

        const imageBadgeAlt = `${productDisplayName} ${
            skuBadgeImage ? skuBadgeImageAlt : productBadgeImageAlt
        }`;

        const imageBadgeSrc = skuBadgeImage || productBadgeImage;

        return (
            <img
                className={productImageBadgeClassNames}
                data-test-id={PRODUCT_IMAGE_BADGE}
                src={imageBadgeSrc}
                alt={imageBadgeAlt}
            />
        );
    })
);
